/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { useEffect, useState } from "react";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { Button, Segment } from "semantic-ui-react";
import { TextField } from "@mui/material";
import getFoiFromFli from "../functions/getFoiFromFliAPI";

const getFliReturn = async (fli, apiToken, setFliReturnState, setFliToProcessState) => {
    let response = await getFoiFromFli(fli, apiToken);
    if (response?.success) {
        setFliReturnState({ "foi": response.formstateid, "resourceType": response.resourcetype });
    } else {
        let trimmedFli = fli.trim();
        let response2 = await getFoiFromFli(trimmedFli, apiToken);
        if (response2?.success) {
            setFliReturnState({ "foi": response2.formstateid, "resourceType": response2.resourcetype });
        } else {
            alert("Page not found. Perhaps you tried to use a FEvIR Linking Identifier. If so, a resource by that FEvIR Linking Identifier does not exist, or you're not allowed to view it.\n\n" + fli);
            setFliToProcessState({ "fliToProcess": "" });
        }
    }
}

// eslint-disable-next-line no-empty-pattern
const FliToFoiPage = ({ }) => {

    const { fli } = useParams();
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const navigate = useNavigate();

    const [fliEntryState, setFliEntryState] = useState({ "fli": "" });
    const [urlFliState, setUrlFliState] = useState({ "fli": "", "checked": false });
    const [fliToProcessState, setFliToProcessState] = useState({ "fliToProcess": "" });
    const [fliReturnState, setFliReturnState] = useState({});

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR FLI to FOI"));
        if (fli) {
            setUrlFliState(prevState => { return { ...prevState, "fli": fli }; });
        }
    }, []);

    useEffect(() => {
        if (urlFliState?.fli && urlFliState.checked === false) {
            setUrlFliState(prevState => { return { ...prevState, "checked": true }; });
            getFliReturn(urlFliState.fli, apiToken, setFliReturnState, setFliToProcessState);
        }
    }, [urlFliState]);

    useEffect(() => {
        if (fliToProcessState?.fliToProcess) {
            getFliReturn(fliToProcessState.fliToProcess, apiToken, setFliReturnState, setFliToProcessState);
        }
    }, [fliToProcessState]);

    useEffect(() => {
        if (fliReturnState?.foi) {
            //dispatch(changeFoiFocus(fliReturnState.foi));
            navigate("/resources/" + (fliReturnState.resourceType || "Resource") + "/" + fliReturnState.foi);
        }
    }, [fliReturnState]);

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            <h2 style={{ textAlign: "center", color: "#AC3B61" }}>View a Resource by FEvIR Linking Identifier</h2>
            <br /><br />
            <TextField style={{ width: "480px" }} multiline
                className="inputField" type='text'
                label={'FEvIR Linking Identifier'}
                size="small" variant='outlined'
                value={fliEntryState.fli}
                onChange={(e) => { setFliEntryState({ "fli": e.target.value }); }} />
            <br /><br />
            <Button className="formButton positive" content="View Resource" compact
                onClick={() => { setFliToProcessState({ "fliToProcess": fliEntryState.fli }); }}
                disabled={!(fliEntryState?.fli)} />
            <br /><br />
            <Button className="formButton platformButton"
                style={{ color: "#000000", width: "25%" }}
                content="Go to Search Page"
                onClick={() => {
                    navigate("/search")
                }}
            />
        </Segment>
    </div>;
};

export default FliToFoiPage;